import DeclinedEngagementsChart from './DeclinedEngagementsChart';

export default DeclinedEngagementsChart;
